import { render, staticRenderFns } from "./OfferName.vue?vue&type=template&id=5c7f25d2&scoped=true&"
import script from "./OfferName.vue?vue&type=script&lang=js&"
export * from "./OfferName.vue?vue&type=script&lang=js&"
import style0 from "./OfferName.vue?vue&type=style&index=0&id=5c7f25d2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c7f25d2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/app/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
installComponents(component, {VIcon,VLayout})
